import React from 'react';
import type { TdsOutVarItem } from '../../../types/testDataCharts.types';

interface OutsideVarTableProps {
  tdsOutVarList: TdsOutVarItem[];
  numeratorName: string;
  denominatorName: string;
  outsideVarName: string;
}

/** Rounds value to 4 decimal places, matching legacy formatValueForDisplay. */
function formatValue(value: number): string {
  return (Math.round(value * 10000) / 10000).toString();
}

const OutsideVarTable: React.FC<OutsideVarTableProps> = ({
  tdsOutVarList,
  numeratorName,
  denominatorName,
  outsideVarName,
}) => {
  const resolvedOutsideVarName = outsideVarName.trim() === '' ? 'Other' : outsideVarName;

  return (
    <div className="overflow-x-auto w-full">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-blue-900 text-white">
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">{resolvedOutsideVarName}</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">
              Total {numeratorName || 'Numerator'}
            </th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">
              Total {denominatorName || 'Denominator'}
            </th>
            <th className="px-3 py-2 text-right font-semibold border border-blue-800">Total Average</th>
          </tr>
        </thead>
        <tbody>
          {tdsOutVarList.map((item, idx) => {
            const sumValue =
              item.sumDenominator === 0
                ? '0'
                : formatValue(item.sumNumerator / item.sumDenominator);
            const label = item.outsideVarValue === null || item.outsideVarValue === '' ? '' : item.outsideVarValue;
            return (
              <tr
                key={label + idx}
                className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
              >
                <td className="px-3 py-2 border border-gray-200">{label}</td>
                <td className="px-3 py-2 border border-gray-200">{item.sumNumerator}</td>
                <td className="px-3 py-2 border border-gray-200">{item.sumDenominator}</td>
                <td className="px-3 py-2 border border-gray-200 text-right">{sumValue}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OutsideVarTable;
